// extracted by css-extract-rspack-plugin
export default {"Container":"DataSelectorSectionHeader-module__Container___ArYt_","Header":"DataSelectorSectionHeader-module__Header___u0jW_"};